import * as React from "react";
import useSelector from "src/utils/useSelector";
import { useTranslation } from "react-i18next";
import "./ManualTradeEstimate.scss";
import { TradeIn } from "Types/TradeIn";
import { ManualEstimateInput } from "src/components/ManualTradeEstimate/ManualTradeInput";

const manualEstimateFieldNames = ["year", "make", "model", "trim", "customer_estimate"];
export const ManualEstimate = ({
    isDrawer,
    tradePending,
    uuid,
    onChangePatchTradePending,
}: {
    isDrawer: boolean;
    tradePending: Partial<TradeIn>;
    uuid: string;
    onChangePatchTradePending: (tradePending: TradeIn, uuid: string) => void;
}) => {
    const { t } = useTranslation();
    const country = useSelector((state) => state.account.address?.country ?? "US");

    return (
        <div className={`manual-estimate${!isDrawer ? "-container" : "-in-drawer"}`} data-e2e="manualTradeContainer">
            <div className="manual-estimate-header">
                <span className="manual-estimate-header-text">{t("TradePending.ManualInputs.header2")}</span>
            </div>
            <form>
                <div className="manual-estimate-form-wrapper">
                    {manualEstimateFieldNames.map((name) => (
                        <ManualEstimateInput
                            key={name}
                            name={name}
                            uuid={uuid}
                            onChangePatchTradePending={onChangePatchTradePending}
                            country={country}
                            tradePending={tradePending}
                        />
                    ))}
                </div>
            </form>
        </div>
    );
};
